var map = {
	"./info-sharing-center-de.html": 1024,
	"./info-sharing-center-en.html": 1025,
	"./info-sharing-center-es.html": 1026,
	"./info-sharing-center-fr.html": 1027,
	"./info-sharing-center-ja.html": 1028,
	"./info-sharing-center-pt.html": 1029,
	"./info-sharing-center-zh.html": 1030
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1023;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-center ^\.\/info\-sharing\-center\-.*\.html$
// module id = 1023
// module chunks = 0